// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"a4939e38","204":"aacb7da4","508":"24871c94","878":"40b8f6fb","977":"21c8e98d","994":"36f21730"}[chunkId] + ".chunk.css";
};